import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import Customer from "./util/Customer";
import PricingBlock from "./util/PricingBlock";
import UploadBlock from "./upload/UploadBlock";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import blueLeftBackground from "../img/v2/home/blueLeftBackground.png";
import blueRightBackground from "../img/v2/home/blueRightBackground.png";
import hiwStep1V2 from "../img/v2/home/hiw/step-1.png";
import hiwStep2V2 from "../img/v2/home/hiw/step-2.png";
import hiwStep3V2 from "../img/v2/home/hiw/step-3.png";
import decriptionImage1V2 from "../img/v2/home/description/image1.png";
import decriptionImage2V2 from "../img/v2/home/description/image2.png";
import decriptionImage3V2 from "../img/v2/home/description/image3.png";
import decriptionImage4V2 from "../img/v2/home/description/image4.png";
import decriptionImage5V2 from "../img/v2/home/description/image5.png";
import decriptionImage6V2 from "../img/v2/home/description/image6.png";
import hiwStepCompress1V2 from "../img/v2/home/hiw/step-pdf-1.png";
import hiwStepCompress2V2 from "../img/v2/home/hiw/step-pdf-2.png";
import hiwStepCompress3V2 from "../img/v2/home/hiw/step-pdf-3.png";
import hiwStepSplit1V2 from "../img/v2/home/hiw/step-split-1.png";
import hiwStepSplit2V2 from "../img/v2/home/hiw/step-split-2.png";

import "../scss/v2/home.scss"

function Home(props) {
  const { t, i18n } = useTranslation();
  const hiwBlockRef = useRef(null);
  let location = useLocation();

  useEffect(() => {
    i18n.changeLanguage(props.lang);
    if (
      hiwBlockRef &&
      (location.hash.includes("#how-it-works") ||
        location.hash.includes("#howItWorks"))
    ) {
      setTimeout(function () {
        window.scrollTo(0, hiwBlockRef.current.getBoundingClientRect().y);
      }, 10);
    }
  }, [i18n, props.lang, hiwBlockRef, location.hash]);

  const renderHIW = () => {
    if (props.compress) {
      return (
        <div className="container homepage-hiw-block">
          <div className="row">
            <div className="col-12">
              <h2 className="homepage-hiw-block-title">
                {t("homepageCompress.hiwBlock.title")}
              </h2>
            </div>
            <div className="col-12 col-lg-4">
              <div className="homepage-hiw-block-element">
                <img className="img img-fluid homepage-hiw-block-element-image" src={hiwStepCompress1V2} alt={hiwStepCompress1V2} />
                <p className="homepage-hiw-block-element-title">{t("homepageCompress.hiwBlock.element.1.title")}</p>
                <p className="homepage-hiw-block-element-description">{t("homepageCompress.hiwBlock.element.1.description")}</p>
                <div className="homepage-hiw-block-element-arrow">
                  <FontAwesomeIcon icon={faArrowUp} />
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="homepage-hiw-block-element">
                <img
                  className="img img-fluid homepage-hiw-block-element-image"
                  src={hiwStepCompress2V2}
                  alt={hiwStepCompress2V2}
                />
                <p className="homepage-hiw-block-element-title">
                  {t("homepageCompress.hiwBlock.element.2.title")}
                </p>
                <p className="homepage-hiw-block-element-description">
                  {t("homepageCompress.hiwBlock.element.2.description")}
                </p>
                <div className="homepage-hiw-block-element-arrow">
                  <FontAwesomeIcon icon={faArrowUp} />
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="homepage-hiw-block-element">
                <img
                  className="img img-fluid homepage-hiw-block-element-image"
                  src={hiwStepCompress3V2}
                  alt={hiwStepCompress3V2}
                />
                <p className="homepage-hiw-block-element-title">
                  {t("homepageCompress.hiwBlock.element.3.title")}
                </p>
                <p className="homepage-hiw-block-element-description">
                  {t("homepageCompress.hiwBlock.element.3.description")}
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (props.split) {
      return (
        <div id="how-it-works" className="container homepage-hiw-block">
          <div className="row">
            <div className="col-12">
              <h2 className="homepage-hiw-block-title">{t("homepageSplit.hiwBlock.title")}</h2>
            </div>
            <div className="col-12 col-lg-4">
              <div className="homepage-hiw-block-element">
                <img className="img img-fluid homepage-hiw-block-element-image" src={hiwStepSplit1V2} alt={hiwStepSplit1V2} />
                <p className="homepage-hiw-block-element-title">{t("homepageSplit.hiwBlock.element.1.title")}</p>
                <p className="homepage-hiw-block-element-description">{t("homepageSplit.hiwBlock.element.1.description")}</p>
                <div className="homepage-hiw-block-element-arrow">
                  <FontAwesomeIcon icon={faArrowUp} />
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="homepage-hiw-block-element">
                <img className="img img-fluid homepage-hiw-block-element-image" src={hiwStepSplit2V2} alt={hiwStepSplit2V2} />
                <p className="homepage-hiw-block-element-title"> {t("homepageSplit.hiwBlock.element.2.title")}</p>
                <p className="homepage-hiw-block-element-description">{t("homepageSplit.hiwBlock.element.2.description")}</p>
                <div className="homepage-hiw-block-element-arrow">
                  <FontAwesomeIcon icon={faArrowUp} />
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="homepage-hiw-block-element">
                <img className="img img-fluid homepage-hiw-block-element-image" src={hiwStepCompress3V2} alt={hiwStepCompress3V2} />
                <p className="homepage-hiw-block-element-title">{t("homepageSplit.hiwBlock.element.3.title")}</p>
                <p className="homepage-hiw-block-element-description">{t("homepageSplit.hiwBlock.element.3.description")}</p>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="container homepage-hiw-block">
        <div className="row">
          <div className="col-12">
            <h2 className="homepage-hiw-block-title">
              {t("homepage.hiwBlock.title")}
            </h2>
          </div>
          <div className="col-12 col-lg-4">
            <div className="homepage-hiw-block-element">
              <img
                className="img img-fluid homepage-hiw-block-element-image"
                src={hiwStep1V2}
                alt={hiwStep1V2}
              />
              <p className="homepage-hiw-block-element-title">
                {t("homepage.hiwBlock.element.1.title")}
              </p>
              <p className="homepage-hiw-block-element-description">
                {t("homepage.hiwBlock.element.1.description")}
              </p>
              <div className="homepage-hiw-block-element-arrow">
                <FontAwesomeIcon icon={faArrowUp} />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-4">
            <div className="homepage-hiw-block-element">
              <img
                className="img img-fluid homepage-hiw-block-element-image"
                src={hiwStep2V2}
                alt={hiwStep2V2}
              />
              <span className="homepage-hiw-uploaded-span">
                {t("homepage.hiwBlock.element.2.image.text")}
              </span>
              <p className="homepage-hiw-block-element-title">
                {t("homepage.hiwBlock.element.2.title")}
              </p>
              <p className="homepage-hiw-block-element-description">
                {t("homepage.hiwBlock.element.2.description")}
              </p>
              <div className="homepage-hiw-block-element-arrow">
                <FontAwesomeIcon icon={faArrowUp} />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-4">
            <div className="homepage-hiw-block-element">
              <img
                className="img img-fluid homepage-hiw-block-element-image"
                src={hiwStep3V2}
                alt={hiwStep3V2}
              />
              <p className="homepage-hiw-block-element-title">
                {t("homepage.hiwBlock.element.3.title")}
              </p>
              <p className="homepage-hiw-block-element-description">
                {t("homepage.hiwBlock.element.3.description")}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="homepage">
      <Helmet>
        <title>{t(`meta.title.home${!!props.format ? `-${props.format.toLowerCase()}` : ""}`)}</title>
        <meta name="description" content={t(`meta.description.home${!!props.format ? `-${props.format.toLowerCase()}` : ""}`)} />
      </Helmet>
      <div className="container homepage-top-block">
        <div className="text-center">
          <h1 className="homepage-top-title">{t(`homepage.uploadBlock${!!props.format ? `.${props.format.toLowerCase()}` : ""}.title`)}</h1>
          <p className="homepage-top-subtitle">{t(props.compress ? "homepage.uploadBlock.subtitleCompress" : props.split ? "homepage.uploadBlock.subtitleSplit" : "homepage.uploadBlock.subtitle")}</p>
        </div>
        <div className="square-background">
          <img className="img img-fluid left-square-background" src={blueLeftBackground} alt={blueLeftBackground} />
          <div className="square-bakground-content">
            <div className="row">
              <div className="col-12 col-lg-8 offset-lg-2">
                <UploadBlock format={props.format} compress={props.compress} split={props.split} />
              </div>
            </div>
          </div>
          <img
            className="img img-fluid right-square-background"
            src={blueRightBackground}
            alt={blueRightBackground}
          />
        </div>
      </div>
      <div id="how-it-works" ref={hiwBlockRef}>
        {renderHIW()}
      </div>
      <div className="container homepage-description-block">
        <div className="row">
          <div className="col-12 text-center">
            <h2 className="homepage-description-title">
              {t("homepage.descriptionBlock.title")}
            </h2>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="homepage-description-element">
              <img
                className="img img-fluid homepage-description-element-image"
                src={decriptionImage1V2}
                alt={decriptionImage1V2}
              />
              <p className="homepage-description-element-text">
                {t("homepage.descriptionBlock.element.1")}
              </p>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="homepage-description-element">
              <img
                className="img img-fluid homepage-description-element-image"
                src={decriptionImage2V2}
                alt={decriptionImage2V2}
              />
              <p className="homepage-description-element-text">
                {t("homepage.descriptionBlock.element.2")}
              </p>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="homepage-description-element">
              <img
                className="img img-fluid homepage-description-element-image"
                src={decriptionImage3V2}
                alt={decriptionImage3V2}
              />
              <p className="homepage-description-element-text">
                {t("homepage.descriptionBlock.element.3")}
              </p>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="homepage-description-element">
              <img
                className="img img-fluid homepage-description-element-image"
                src={decriptionImage4V2}
                alt={decriptionImage4V2}
              />
              <p className="homepage-description-element-text">{t("homepage.descriptionBlock.element.4")}</p>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="homepage-description-element">
              <img className="img img-fluid homepage-description-element-image" src={decriptionImage5V2} alt={decriptionImage5V2} />
              <p className="homepage-description-element-text">{t("homepage.descriptionBlock.element.5")}</p>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="homepage-description-element">
              <img className="img img-fluid homepage-description-element-image" src={decriptionImage6V2} alt={decriptionImage6V2} />
              <p className="homepage-description-element-text">{t("homepage.descriptionBlock.element.6")}</p>
            </div>
          </div>
        </div>
      </div>
      <PricingBlock />
      <Customer />
      <div className="container text-center">
        <p className="homepage-bottom-element-text">{t(props.compress ? "homepage.bottomText.compress.text" : props.split ? "homepage.bottomText.split.text" : "homepage.bottomText.convert.text")}</p>
      </div>
    </div>
  );
}

export default Home;
